<template>
    <div class="customer-list-wrapper">
<!--        <div class="row">-->
<!--            <div class="col-12">-->
<!--                <button type="button" class="btn text-light btn-link bg-danger mr-1 pull-right" @click="deleteLogs">-->
<!--                    Clear logs-->
<!--                </button>-->
<!--            </div>-->
<!--        </div>-->

      <div class="row">
        <div class="col-md-12">
          <h5>Search By:</h5>
          <div class="m-2 row">
            <div class="col-md-3 form-check-radio">
              <label class="form-check-label">
                <input class="form-check-input" v-model="searchBy" type="radio" name="searchBy" id="inputDomain" value="inputDomain"> Input Domain
                <span class="form-check-sign"></span>
              </label>
            </div>
            <div class="col-md-2 form-check-radio">
              <label class="form-check-label">
                <input class="form-check-input" v-model="searchBy" type="radio" name="searchBy" id="status" value="status"> Status
                <span class="form-check-sign"></span>
              </label>
            </div>
            <div class="col-md-2 form-check-radio">
              <label class="form-check-label">
                <input class="form-check-input" v-model="searchBy" type="radio" name="jobName" id="jobName" value="jobName"> Job Name
                <span class="form-check-sign"></span>
              </label>
            </div>
            <div class="col-md-2 form-check-radio">
              <label class="form-check-label">
                <input class="form-check-input" v-model="searchBy" type="radio" name="ip" id="ip" value="ip"> IP
                <span class="form-check-sign"></span>
              </label>
            </div>
            <div class="col-md-3 form-check-radio">
              <label class="form-check-label">
                <input class="form-check-input" v-model="searchBy" type="radio" name="loginAttempts" id="loginAttempts" value="loginAttempts"> Failed Login Attempts
                <span class="form-check-sign"></span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div v-if="searchBy" class="row mb-2">
        <div class="col-md-3">
          <input @keyup.enter="fetchJobs" v-if="searchBy === 'inputDomain' || searchBy === 'ip' || searchBy === 'jobName' || searchBy === 'loginAttempts'" v-model="searchQuery" type="text" class="form-control mt-2" :placeholder="searchBy ==='loginAttempts' ? 'Search By Email' : 'Search in Logs list'" />
          <div v-else class="form-group">
            <select class="form-control" v-model="searchQuery">
              <option v-for="(search, index) in searchData" v-if="search.for === searchBy" :value="search.value" v-bind:key="index"> {{ search.name }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-3">
          <button class="btn btn-primary btn-sm" v-on:click="fetchJobs" :disabled="loading">
            Search
          </button>
          <button class="btn btn-danger btn-sm" v-on:click="refreshLogs">
            Clear
          </button>
        </div>
      </div>
        <div class="customer-list-info"  v-if="(logs.length === 0 && noLogs === false) || !asyncDone">
            <div class="loader">
                <h3 style="position: relative;top: 125px;width: 500px;left: -80px;">{{asyncText}}</h3>
            </div>
        </div>
        <div v-else-if="noLogs && asyncDone" class="customer-list-info">
          <p class="card-text text-center text-danger mb-3 font-weight-bold">There are no
            logs in the database to show here.</p>
        </div>
        <div class="customer-table" v-else-if="logs.length > 0">
            <table id="job-log-datatable" class="table table-striped table-bordered table-responsive w-100">
                <thead>
                <tr>
                    <th>Job ID</th>
                    <th>Title</th>
                    <th>Initiated By</th>
                    <th>IP</th>
                    <th>Input Domain</th>
                    <th>Status</th>
                    <th>Report</th>
                    <th>Created At</th>
                    <th>Completed At</th>
                    <th>Action</th>
                </tr>
                </thead>
                <tfoot>
                <tr>
                    <th>Job ID</th>
                    <th>Title</th>
                    <th>Initiated By</th>
                    <th>IP</th>
                    <th>Input Domain</th>
                    <th>Status</th>
                    <th>Report</th>
                    <th>Created At</th>
                    <th>Completed At</th>
                    <th>Action</th>
                </tr>
                </tfoot>
                <tbody>
                <tr v-for="(log, index) in logs" :key="index">
                    <td width="14%">{{ log.docID }}</td>
                    <td width="10%">{{ log.jobName }}</td>
                    <td v-if="log.collaborator">{{ log.collaboratorName + '(A Collaborator)' }}</td>
                    <td v-else>{{ log.user.firstName + ' ' + log.user.lastName }}</td>
                    <td>{{log.jobData ? log.jobData.ip || 'N/A' : 'N/A'}}</td>
                    <td :title="log.inputDomain">{{ log.inputDomain }}</td>
                    <td class="text-center">
                        <span class="badge badge-pill badge-success" v-if="log.status === 'complete' && log.progress === 'success'">Completed</span>
                        <span class="badge badge-pill badge-danger" v-else-if="log.status === 'complete' && log.progress === 'error'">Error</span>
                        <span class="badge badge-pill badge-danger" v-else-if="log.status === 'stop' && log.progress === 'error'">Stopped</span>
                        <span class="badge badge-pill badge-warning" v-else-if="log.status === 'Pending'">Pending</span>
                        <span class="badge badge-pill badge-warning" v-else-if="log.status === 'paused'">Paused</span>
                        <span class="badge badge-pill badge-default" v-else>Running</span>
                    </td>
                    <td class="text-center">
                        <span :class="['badge badge-pill ', (log.progress === 'error') ? 'badge-danger' : 'badge-success']" style="">{{log.progress}}</span>
                    </td>
                    <td width="13%">{{ log.createdAt | formatDate }}</td>
                    <td width="15%"><span v-if="log.completedAt">{{ log.completedAt | formatDate }}</span></td>
                    <td width="10%" class="text-center">
                      <div style="display: flex">
                        <button class="btn btn-primary btn-sm mr-2" @click="viewLogs(log)"><i class="fa fa-eye"></i></button>
                        <button v-if="log.jobName === 'too-many-login-requests'" title="Refresh Account Access" :disabled="refreshLoader" class="btn btn-primary btn-sm mr-2" @click="refreshAccountAccess(log)"><i class="fa fa-refresh"></i></button>
                        <button v-if="log.jobName === 'CHECK-SERVER-CRON'" title="Retry Now" :disabled="retryLoader === log.docID" class="btn btn-success btn-sm mr-2" @click="retryCheckServer(log)"><i class="fa fa-refresh"></i></button>
                        <div v-if="log.status === 'paused'" :disabled="loader" class="dropdown">
                          <template v-if="log.jobName === 'backup-job'">
                            <button title="Resume this job" class="btn btn-success btn-sm mr-2" type="button" @click="resumeJob(log, true)">
                              <div v-if="loader" class="loader mini_loader"></div>
                              <i v-else class="fa fa-check"></i>
                            </button>
                          </template>
                          <template v-else>
                            <button title="Resume this job" class="btn btn-success btn-sm mr-2 dropdown-toggle" type="button" id="dropdownMenuButton1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              <div v-if="loader" class="loader mini_loader"></div>
                              <i v-else class="fa fa-check"></i>
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                              <a class="dropdown-item" @click="resumeJob(log, false)" href="javascript:void(0)">Normal</a>
                              <a class="dropdown-item" @click="resumeJob(log, true)" href="javascript:void(0)">Forced</a>
                            </div>
                          </template>
                        </div>
                        <button v-if="log.status === 'running' && (user.userType === 'admin' || user.userType === 'super-admin') " title="Mark as completed" class="btn btn-success btn-sm mr-2" :disabled="loader" @click="completeJob(log)">
                          <div v-if="loader" class="loader mini_loader"></div>
                          <i v-else class="fa fa-check"></i>
                        </button>
                        <button class="btn btn-danger btn-sm mr-2" :disabled="loader || user.userType !== 'admin' || user.userType === 'super-admin'" @click="deleteSingleLog(log)">
                          <div v-if="loader" class="loader mini_loader"></div>
                          <i v-else class="fa fa-times"></i>
                        </button>
                        <button class="btn btn-primary btn-sm" title="Login as user" @click="loginAsUser(log)">
                          <i class="fa fa-user"></i>
                        </button>
                      </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="row mt-2">
          <div class="col-md-12 text-center">
            <span class="pull-left mt-2"><b>Page Number: </b> {{ pageNumber + 1 }}</span>
            <button class="btn btn-link btn-sm btn-round" :disabled="pageNumber === 0" v-on:click="prevPage">
              Prev
            </button>
            <button class="btn btn-link btn-sm btn-round" :disabled="logs.length < pageSize" v-on:click="nextPage">
              Next
            </button>
          </div>
        </div>
        <div class="view-log-modal">
            <div class="modal fade" tabindex="-1" role="dialog" id="viewLogsModal" aria-hidden="true">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h6 class="modal-title">Job: {{selectedLog.docID}}</h6>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <h6>Input data for this job:</h6>
                            <code>
                                <ol>
                                    <li v-for="(value, propertyName) in selectedLog.jobData" :key="propertyName">
                                        <template v-if="!uselessJobData.includes(propertyName)">
                                            <span>{{propertyName}}</span> : <b>{{value}}</b>
                                        </template>
                                    </li>
                                </ol>
                            </code>
                            <h6 style="margin-top: 10px">Logs</h6>
                            <code>
                                <ol>
                                    <li v-for="(log, index) in selectedLog.logs" :key="'logVal_' + index">
                                        <span :class="[(log.type === 'info') ? 'info' : 'danger']">{{log.date | formatDate}}</span> |
                                        <span :class="['badge', (log.type === 'info') ? 'badge-success' : 'badge-danger']">{{log.type}}</span> |
                                        <span :class="[(log.type === 'info') ? 'info' : 'danger']">{{log.log}}</span>
                                    </li>
                                </ol>
                            </code>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {db} from "@/firebase/init";
    import swal from 'sweetalert2';
    import moment from "moment";
    export default {
        name: "JobLogList",
        data() {
            return {
                refreshLoader: false,
                retryLoader: false,
                dt: null,
                loader:false,
                loading:false,
                initDataTable: true,
                selectedLog: {},
                logs: [],
                noLogs: false,
                uselessJobData: ['token', 'addonDomainStructure', 'user'],
                searchBy: 'inputDomain',
                searchQuery: '',
                pageSize: 10,
                pageNumber: 0,
                searchData: [{
                  for: 'status',
                  value: 'complete',
                  name: 'Completed'
                },{
                  for: 'status',
                  value: 'stop',
                  name: 'Stopped'
                },{
                  for: 'status',
                  value: 'Pending',
                  name: 'Pending'
                },{
                  for: 'status',
                  value: 'paused',
                  name: 'Paused'
                },{
                  for: 'status',
                  value: 'running',
                  name: 'Running'
                },{
                  for: 'progress',
                  value: 'success',
                  name: 'Success'
                },{
                  for: 'progress',
                  value: 'error',
                  name: 'Error'
                }]
            };
        },
      watch: {
        searchBy () {
          this.refreshLogs();
        }
      },
        computed: {
            asyncDone() {
                return this.$store.getters["async/state"];
            },
            asyncText() {
                return this.$store.getters["async/text"];
            },
            last () {
              return (this.logs.length > 0) ? this.logs[this.logs.length-1] : null;
            },
            first () {
              return (this.logs.length > 0) ? this.logs[0] : null;
            },
            user() {
              return this.$store.getters.user;
            }
        },
        created () {
            this.fetchJobs();
        },
        updated () {
            if(this.initDataTable){
                console.log('init data tables....');
                /* eslint-disable */
                // this.dt = $("#job-log-datatable").DataTable({
                //     pagingType: "full_numbers",
                //     lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "All"]],
                //     responsive: true,
                //     "destroy": true,
                //     columnDefs: [
                //         { orderable: false, targets: [0,1,2,3,4,5,7,8] }
                //     ],
                //     order: [[6, "desc"]],
                //     language: {
                //         search: "_INPUT_",
                //         searchPlaceholder: "Search records"
                //     }
                // });
                /* eslint-enable */
                this.initDataTable = false;
            }

        },
        methods: {
          loginAsUser (data) {
            console.log(data)
            try {
              this.loader = true;
              if (data.user && data.user.id) {
                window.open(`https://wpo.bigscoots.com/user/dashboard?id=${data.user.id}`,'WPO-Bigscoots');
              }
            } catch (e) {
              console.log(e.toString())
              swal('Error', 'Unable to login to user account!', 'error')
            } finally {
              this.loader = false;
            }
          },
          async retryCheckServer(job) {
            try {
              this.retryLoader = job.docID
              await this.$http.post('/utilities/check-new-servers', {
                docID: job.docID,
                grant_type: 'token'
              })
              swal('Success!', 'Job has been completed.', 'success');
            }catch (e) {
              console.log(e)
              swal('Error!', 'Error in running this job.', 'error');
            }
            this.retryLoader = false
          },
          async refreshAccountAccess(log) {
            try {
              this.refreshLoader = true;
              const response = await this.$http.post('/sign-up/refresh-account-access', {
                userEmail: log.jobData.email
              });
              log.logs.push({date: new Date().toISOString(), log: 'Email has been sent to the user to refresh account access!', type: 'info'})
              await db.collection('jobLogs').doc(log.docID).update({logs: log.logs});
              swal('Success!', response.data.message, 'success');
            } catch (e) {
              console.log(e.toString())
              console.log('error', e.response)
              swal('Error!', 'Something went wrong while refreshing account access!', 'error');
            } finally {
              this.refreshLoader = false;
            }
          },
          viewLogs (log) {
              console.log(log);
              this.selectedLog = log;
              /* eslint-disable */
              $("#viewLogsModal").modal("show");
              $(document).ready(function () {
                  $(".modal-backdrop").appendTo(".view-log-modal");
              });
              /* eslint-enable */
          },
          refreshLogs () {
            this.searchQuery = '';
            this.noLogs = false;
            this.pageNumber = 0;
            this.fetchJobs();
          },
          async fetchJobs () {
              /* eslint-disable */
              // if ($.fn.DataTable.isDataTable("#datatable")) {
              //     $('#job-log-datatable').DataTable().destroy();
              // }
              /* eslint-enable */
              this.logs = [];
              this.noLogs = false;
              this.loading = true;
              this.pageNumber = 0;
              let ref = db.collection('jobLogs');
              let docs = [];
              try {
                if (this.searchQuery || this.searchBy === 'loginAttempts') {
                  if (this.searchBy === 'ip') {
                    console.log('here')
                    docs = await  ref
                        .where('jobData.ip', "==", this.searchQuery)
                        .orderBy("createdAt", "desc")
                        .limit(this.pageSize)
                        .get();
                  } else if (this.searchBy === 'loginAttempts') {
                    ref = ref.where('jobName', "==", 'too-many-login-requests')
                    if (this.searchQuery) {
                      ref = ref.where('jobData.email', "==", this.searchQuery.toLowerCase())
                    }
                    docs = await  ref
                        .orderBy("createdAt", "desc")
                        .limit(this.pageSize)
                        .get();
                  } else if (this.searchBy === 'inputDomain') {
                    docs = await  ref
                        .where('inputDomain', '>=',  this.searchQuery.trim().toLowerCase())
                        .where('inputDomain', '<=', this.searchQuery.trim().toLowerCase() + '\uf8ff')
                        .orderBy('inputDomain', 'desc')
                        .orderBy('createdAt', 'desc')
                        .limit(this.pageSize)
                        .get();
                  } else {
                    docs = await  ref
                        .where(this.searchBy, "==", this.searchBy !== 'status' ? this.searchQuery.toLowerCase() : this.searchQuery)
                        .orderBy("createdAt", "desc")
                        .limit(this.pageSize)
                        .get();
                  }
                } else {
                  docs = await ref
                      .orderBy("createdAt", "desc")
                      .limit(this.pageSize)
                      .get()
                }
                if (docs.empty === true) {
                  this.noLogs = true;
                }
                docs.forEach(doc => {
                  this.logs.push({
                    docID: doc.id,
                    ...doc.data()
                  })
                });
              } catch (err) {
                console.error(err);
                // Show error message to the customer for 5 sec
                this.$store.dispatch("alert/update", {
                  type: "danger",
                  message: err.name,
                  show: true
                });

                setTimeout(() => {
                  this.$store.dispatch("alert/showUpdate", {show: false});
                }, 5000);
              }
            this.loading = false;
          },
          deleteLogs () {
              swal({
                  title: "Are you sure?",
                  text: 'Please confirm that you want flush all background job logging?',
                  type: "question",
                  confirmButtonText: "Yes Proceed",
                  confirmButtonColor: "#6ACF98",
                  showCancelButton: true,
                  cancelButtonText: "No Thanks",
                  cancelButtonColor: "#EE8057"
              })
                  .then( result => {
                      // Check if the user has clicked YES
                      if(result.value) {
                          let collectionRef = db.collection("jobLogs");
                          collectionRef.get().then(async docs => {
                              const batchSize = 500;
                              let totalBatches = Math.ceil(docs.size / batchSize);
                              let docReferences = [];
                              docs.forEach(doc => {
                                  docReferences.push(doc.ref);
                              });
                              for(let b = 0; b < totalBatches; b++) {
                                  this.$store.dispatch("async/stateUpdate", {state: false, text: 'Deleting Batch: ' + (b + 1) + '/' + totalBatches});
                                  let batch = db.batch();
                                  let startIndex = b * batchSize;
                                  let endIndex = (((batchSize + startIndex) < docs.size)) ? batchSize + startIndex : docs.size;
                                  console.log(startIndex, endIndex);
                                  for(let d = startIndex; d < endIndex; d++){
                                      batch.delete(docReferences[d]);
                                  }
                                  await batch.commit();
                              }
                              this.$store.dispatch("async/stateUpdate", {state: true, text: ''});
                              await this.addLog({
                                message: 'User has deleted all job logs.',
                                level: "info"
                              })
                              this.initDataTable = true;
                              this.fetchJobs();
                          })
                      }
                  });
          },
          async deleteSingleLog(log){
            /* eslint-disable */
            try {
              this.loader = true;
              let res = null;
              if(log.jobName === 'too-many-login-requests') {
                console.log('inside too many login request condition');
                await db.collection('jobLogs').doc(log.docID).delete()
              } else {
                res = await this.$http.post('/queue/remove_job', {
                  jobId: log.docID
                });
                console.log(res.data);
              }
              swal('Deleted!', 'Job has been successfully deleted from background processing queue as well as from firestore database.', 'success');
              this.fetchJobs();
              this.addLog({
                message: 'User has deleted job log, job:' + log.jobName + ', Domain: ' + log.inputDomain,
                level: "info"
              })
            } catch (e) {
              console.error(e.toString());
              swal('Error!', 'Error in removing job.', 'error');
            } finally {
              this.loader = false;
            }

            // this.$http.post('/queue/remove_job', {
            //     jobId: log.docID
            // }).then(res => {
            //     console.log(res.data);
            //     swal('Deleted!', 'Job has been successfully deleted from background processing queue as well as from firestore database.', 'success');
            //     this.fetchJobs();
            //     this.addLog({
            //       message: 'User has deleted job log, job:' + log.jobName + ', Domain: ' + log.inputDomain,
            //       level: "info"
            //     })
            // }).catch(e => {
            //     console.error(e.toString());
            //     swal('Error!', 'Error in removing job.', 'error');
            // }).finally(() => {
            //     this.loader = false;
            // })
            /* eslint-enable */
          },
          async completeJob (job) {
            this.loader = true
            try {
              await this.$http.post('/utilities/complete-job', {
                docID: job.docID,
                jobData: JSON.stringify(job.jobData),
                completedBy: this.user.firstName + ' ' + this.user.lastName,
                grant_type: 'token'
              })
              await this.fetchJobs()
            } catch (e) {
              console.error(e);
              swal('Error!', 'Error in completing the job. Please try again.')
            }
            this.loader = false
          },
          async resumeJob(job, skip) {
            let jobData = job.jobData;
            jobData.skip=skip
            this.loader = true;
              await db.collection('jobLogs').doc(job.docID).update({
                  status: 'Pending',
                skip
              });
              this.$http.post('/staging-request/resume-job', {
                  jsonData: JSON.stringify(jobData),
                  grant_type: 'token'
              }).then(resp => {
                  console.log(resp.data);
                  if (job.jobName === 'backup-job') {
                    swal('Success', `Backup restore job for domain: ${job.inputDomain} has been restored successfully!`, 'success');
                  } else {
                    swal('Success', resp.data.msg, 'success');
                  }
                  this.fetchJobs();
                  this.addLog({
                    message: 'User has resumed job:' + job.jobName + ', Domain: ' + job.inputDomain,
                    level: "info"
                  })
                  this.loader = false;
              }).catch((err) => {
                  console.error(err);
                  swal('Error!', 'Error in resume the job. Please try again.')
              });
          },
          async nextPage() {
            if (this.last) {
              this.pageNumber ++;
              this.noUser = false;
              this.loading = true;
              this.$store.dispatch("async/stateUpdate", {state: false});
              try {
                let ref = db.collection('jobLogs');
                let docs = [];
                if (this.searchQuery || this.searchBy === 'loginAttempts') {
                  if (this.searchBy === 'ip') {
                    docs = await  ref
                        .where('jobData.ip', "==", this.searchQuery)
                        .orderBy("createdAt", "desc")
                        .startAfter(this.last.createdAt)
                        .limit(this.pageSize)
                        .get();
                  } else if (this.searchBy === 'loginAttempts') {
                    ref = ref.where('jobName', "==", 'too-many-login-requests')
                    if (this.searchQuery) {
                      ref = ref.where('jobData.email', "==", this.searchQuery.toLowerCase())
                    }
                    docs = await  ref
                        .orderBy("createdAt", "desc")
                        .startAfter(this.last.createdAt)
                        .limit(this.pageSize)
                        .get();
                  } else if (this.searchBy === 'inputDomain') {
                    docs = await  ref
                        .where('inputDomain', '>=', this.searchQuery.trim().toLowerCase())
                        .where('inputDomain', '<=', this.searchQuery.trim().toLowerCase() + '\uf8ff')
                        .orderBy("inputDomain", "desc")
                        .orderBy("createdAt", "desc")
                        .startAfter(this.last.inputDomain, this.last.createdAt)
                        .limit(this.pageSize)
                        .get();
                  } else {
                    docs = await  ref
                        .where(this.searchBy, "==", this.searchBy !== 'status' ? this.searchQuery.toLowerCase() : this.searchQuery)
                        .orderBy("createdAt", "desc")
                        .startAfter(this.last.createdAt)
                        .limit(this.pageSize)
                        .get();
                  }
                } else {
                  docs = await ref
                      .orderBy("createdAt", "desc")
                      .limit(this.pageSize)
                      .startAfter(this.last.createdAt)
                      .get()
                }
                if (docs.empty === true) {
                  this.noLogs = true;
                }
                this.logs = [];
                docs.forEach(doc => {
                  this.logs.push({
                    docID: doc.id,
                    ...doc.data()
                  })
                });
                this.$store.dispatch("async/stateUpdate", {state: true});
              } catch (err) {
                console.error(err);
                // Show error message to the customer for 5 sec
                this.$store.dispatch("alert/update", {
                  type: "danger",
                  message: err.name,
                  show: true
                });
                this.$store.dispatch("async/stateUpdate", {state: true});

                setTimeout(() => {
                  this.$store.dispatch("alert/showUpdate", {show: false});
                }, 5000);
              }
              this.loading = false;
            }
          },
          async prevPage(){
          if (this.first) {
            this.pageNumber --;
            this.noUser = false;
            this.loading = true;
            this.$store.dispatch("async/stateUpdate", {state: false});
            try {
              let ref = db.collection('jobLogs');
              let docs = [];
              if (this.searchQuery || this.searchBy === 'loginAttempts') {
                if (this.searchBy === 'ip') {
                  docs = await  ref
                      .where('jobData.ip', "==", this.searchQuery)
                      .orderBy("createdAt", "desc")
                      .endBefore(this.first.createdAt)
                      .limitToLast(this.pageSize)
                      .get();
                } else if (this.searchBy === 'loginAttempts') {
                  ref = ref.where('jobName', "==", 'too-many-login-requests')
                  if (this.searchQuery) {
                    ref = ref.where('jobData.email', "==", this.searchQuery.toLowerCase())
                  }
                  docs = await  ref
                      .orderBy("createdAt", "desc")
                      .endBefore(this.first.createdAt)
                      .limitToLast(this.pageSize)
                      .get();
                } else if (this.searchBy === 'inputDomain'){
                  docs = await  ref
                      .where('inputDomain', '>=', this.searchQuery.trim().toLowerCase())
                      .where('inputDomain', '<=', this.searchQuery.trim().toLowerCase() + '\uf8ff')
                      .orderBy('inputDomain', 'desc')
                      .orderBy('createdAt', 'desc')
                      .endBefore(this.first.inputDomain, this.first.createdAt)
                      .limitToLast(this.pageSize)
                      .get();
                } else {
                  docs = await  ref
                      .where(this.searchBy, "==", this.searchBy !== 'status' ? this.searchQuery.toLowerCase() : this.searchQuery)
                      .orderBy("createdAt", "desc")
                      .endBefore(this.first.createdAt)
                      .limitToLast(this.pageSize)
                      .get();
                }
              } else {
                docs = await ref
                    .orderBy("createdAt", "desc")
                    .endBefore(this.first.createdAt)
                    .limitToLast(this.pageSize)
                    .get()
              }
              if (docs.empty === true) {
                this.noLogs = true;
              }
              this.logs = [];
              docs.forEach(doc => {
                this.logs.push({
                  docID: doc.id,
                  ...doc.data()
                })
              });
              this.$store.dispatch("async/stateUpdate", {state: true});
            } catch (err) {
              console.error(err);
              // Show error message to the customer for 5 sec
              this.$store.dispatch("alert/update", {
                type: "danger",
                message: err.name,
                show: true
              });
              this.$store.dispatch("async/stateUpdate", {state: true});

              setTimeout(() => {
                this.$store.dispatch("alert/showUpdate", {show: false});
              }, 5000);
            }
            this.loading = false;
          }
        }
      }
    }
</script>

<style scoped>
    code {
        background: #f4f4f4;
        border: 1px solid #ddd;
        border-left: 3px solid #2954fa;
        color: #666;
        page-break-inside: avoid;
        font-family: monospace;
        font-size: 12px;
        line-height: 1.6;
        margin-bottom: 1.6em;
        max-width: 100%;
        overflow: auto;
        padding: 1em 1.5em;
        display: block;
        word-wrap: break-word;
    }
    code .info{
        color: #376c4f;
    }
    code .danger{
        color: #cf363e;
    }
</style>
